import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { ProvisionAnswer, ProvisionInput } from '../lib/admin-provision';
import { AdminInviteByEmailForm } from './AdminInviteByEmailForm';
import { AdminProvisionResult } from './AdminProvisionResult';
import { Modal } from './Modal';
import { Button, buttonClass } from './ui/Button';

// The "Invite by email" dialog (plan 102 slice 05): the form, then — once the write
// lands — what it did. THE RESULT REPLACES THE FORM, not a toast: the accept link is
// shown once and nowhere else, so it needs a surface the operator dismisses on
// purpose (`<AdminInviteDialog/>`'s rule). A refused write keeps the form open over
// the API's own sentence. The form is keyed on the open, so every open starts from
// the bundle.

export function AdminInviteByEmailDialog(props: {
  readonly open: boolean;
  readonly busy: boolean;
  readonly error: string | null;
  readonly result: ProvisionAnswer | null;
  readonly onSend: (input: ProvisionInput) => void;
  readonly onClose: () => void;
}): JSX.Element {
  return (
    <Modal
      open={props.open}
      size="lg"
      title={t(props.result === null ? 'admin.invite_email_title' : 'admin.access_invited_title')}
      {...(props.result === null ? { desc: t('admin.invite_email_desc') } : {})}
      onClose={props.onClose}
      footer={
        <Show
          when={props.result === null}
          fallback={<Button onClick={props.onClose}>{t('admin.access_done')}</Button>}
        >
          <Button variant="outline" disabled={props.busy} onClick={props.onClose}>
            {t('admin.access_cancel')}
          </Button>
          <button
            type="submit"
            form="admin-invite-email-form"
            class={buttonClass()}
            disabled={props.busy}
          >
            {t(props.busy ? 'admin.access_sending' : 'admin.access_send')}
          </button>
        </Show>
      }
    >
      <Show
        when={props.result}
        keyed
        fallback={
          <Show when={props.open} keyed>
            {(_open) => (
              <AdminInviteByEmailForm busy={props.busy} error={props.error} onSend={props.onSend} />
            )}
          </Show>
        }
      >
        {(result) => <AdminProvisionResult result={result} />}
      </Show>
    </Modal>
  );
}
